"use client";

import React, { useMemo } from "react";
import { isHTML } from "@/utils";
import classnames from "classnames";
import { AlertProps } from "./types";
import "./styles.scss";

const Alert: React.FC<AlertProps> = ({
  type = "warning",
  className,
  onClose,
  children,
  content,
  showLeftIcon,
  svgIcon,
  closeIcon,
  compact,
  center,
  collapsedMobileTest,
  closeIconClassName = "",
}) => {
  const classNames = classnames("alert", {
    [className || ""]: className,
    "alert--error": type === "error",
    "alert--warning": type === "warning",
    "alert--success": type === "success",
    "alert--light": type === "light",
    "alert--neutral": type === "neutral",
    "alert--compact": compact,
    "alert--leftImg": showLeftIcon,
    "alert--withIcon": svgIcon,
    "alert--center": center,
    "alert--collapsedMobileTest": collapsedMobileTest,
  });

  const message = useMemo(() => {
    if (children) {
      return children;
    }

    if (typeof content === "string" && isHTML(content)) {
      return <span dangerouslySetInnerHTML={{ __html: content }}></span>;
    }

    return content;
  }, [children, content]);

  const handleOnClose = (
    event: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>
  ) => {
    if (typeof onClose === "function") {
      onClose(event);
    }
  };

  return (
    <div
      data-testid="alert"
      className={classNames}>
      {svgIcon && (
        <div
          className="alert__svg"
          data-testid="alert-icon">
          {svgIcon}
        </div>
      )}
      {closeIcon && (
        <div
          data-testid="alert__close"
          className={`alert__close ${closeIconClassName}`}
          onClick={handleOnClose}
          onKeyDown={handleOnClose}
          role="button"
          tabIndex={0}
          aria-label="Close">
          &#10005;
        </div>
      )}
      {message}
    </div>
  );
};

export default Alert;
